(function($) {

	"use strict";

	var fullHeight = function() {
        setTimeout(function () {
            $('.js-fullheight').css('height', $(document).height());
        }, 100);
	};
	fullHeight();

	$('#sidebarCollapse').on('click', function () {
      $('#sidebar').toggleClass('active');
  });

})(jQuery);
